import { render } from "./RouteDashboard.vue?vue&type=template&id=0c0e60d0"
import script from "./RouteDashboard.vue?vue&type=script&lang=js"
export * from "./RouteDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__